import { Switch } from '@/components/ui/switch';
import type { ControlProps } from './types';

/** On or off. The field's title above it names it; the switch says which it is. */
export function SwitchControl({ setting, value, onChange, disabled }: ControlProps) {
  const on = value === true;
  return (
    <div>
      <Switch
        checked={on}
        onCheckedChange={(v) => onChange(v)}
        label={on ? 'On' : 'Off'}
        ariaLabel={setting.ui.title}
        disabled={disabled}
      />
    </div>
  );
}
